import { GridStateManagerService } from "./grid-state-manager.service";

/**
 * Factory function for APP_INITIALIZER - Grid State Management
 * Initializes grid state management by checking for version changes and resetting grid states if needed
 * @param gridStateManager The GridStateManagerService instance
 * @returns A function that initializes grid state management
 */
export function gridStateInitializerFactory(gridStateManager: GridStateManagerService): () => void {
  return () => {
    if (gridStateManager.hasAppVersionChanged()) {
      // NOTE: leaving console statements in at this level for testing
      console.info("Application version changed, resetting all grid states...");
      gridStateManager.resetAllGridStates();
    } else {
      console.info("Application version unchanged, keeping existing grid states.");
    }
  };
}
